const BASE_URL = 'https://www.mlb.com/';
const PATH = 'video/game/';

const getFilmRoomGameUrl = ({
  gamePk,
  locale = 'en',
  appPath = '',
}) => {
  if (!gamePk) {
    return '';
  }
  const langPath = locale === 'es' ? 'es/' : '';
  
  return `${BASE_URL}${langPath}${appPath}${PATH}${gamePk}`;
};

module.exports = {
  getFilmRoomGameUrl
};
